import axios from "axios";

export const inmuebleService = {
  // ============= FUNCIÓN BASE =============
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ============= MÉTODOS PRINCIPALES =============

  // Obtener registro del inmueble
  async getInmueble(idinmueble, token, conexion) {
    const campos = "*";
    const nomtab = "inmueble";
    const nomid = "idinmueble";
    const endpoint = `${conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    const response = await this.apiCall(endpoint, token);

    if (response.status === 200 && response.data) {
      return {
        ...response,
        mappedData: {
          inmueble: this.mapInmuebleData(response.data),
          valores: this.extractValues(response.data),
        },
      };
    }
    return response;
  },

  // Obtener deudas del inmueble
  async getDeudaInmueble(
    idinmueble,
    fecha,
    espiritu,
    factorCambio,
    token,
    conexion,
  ) {
    const endpoint = `${conexion}/api/inmueble/deudainmueble?idinmueble=${idinmueble}&fecha=${fecha}&espiritu=${espiritu}`;
    const response = await this.apiCall(endpoint, token);

    if (response.status === 200) {
      return {
        ...response,
        mappedData: this.mapDeudasInmueble(response.data, factorCambio),
      };
    }
    return response;
  },

  // Obtener facturas relacionadas al inmueble
  async getFacturasRelacionadas(idinmueble, token, conexion) {
    const nomtab = "inmueble";
    const endpoint = `${conexion}/api/inmueble/relacionfacturas?idinmueble=${idinmueble}&nomtab=${nomtab}`;
    return await this.apiCall(endpoint, token);
  },

  // ============= MAPEADORES =============

  // Mapear datos básicos del inmueble
  mapInmuebleData(data) {
    if (!data) return null;
    return {
      codigo: data.idinmueble,
      rif: data.cedulapropie,
      cedula: data.cedulapropie,
      nombre: data.nombrepropie,
      direccion: data.dirpropie1,
    };
  },

  // Mapear deudas del inmueble
  mapDeudasInmueble(data, factorCambio = 1) {
    if (!data || data.length === 0) return { deu: [], his: [] };

    const deu = [];
    const his = [];

    data.forEach((item) => {
      const deudaBase = {
        anio: item.anio,
        mes: item.mes?.replace(/'/g, ""),
        monto: parseFloat(item.mondeu) * parseFloat(factorCambio),
        intereses: parseFloat(item.intmoradeu) * parseFloat(factorCambio),
        recargo: parseFloat(item.recargodeu) * parseFloat(factorCambio),
      };

      if (item.fechapago === null) {
        deu.push(deudaBase);
      } else {
        his.push({
          ...deudaBase,
          descuento: item.mondescue,
          recibo: item.numreci,
          fechapago: item.fechapago,
        });
      }
    });

    return { deu, his };
  },

  // Mapear facturas relacionadas
  mapFacturasRelacionadas(data) {
    if (!data || data.length === 0) return [];
    return data.map((factura) => ({
      idfactura: factura.idfactura,
      numero: factura.numero,
      fecha: factura.fecha,
      monto: factura.monto,
      concepto: factura.concepto,
      estatus: factura.estatus,
      fechapago: factura.fechapago,
      // Agrega más campos según tu API
    }));
  },

  // Extraer valores comunes del inmueble
  extractValues(data) {
    return {
      idinmueble: data?.idinmueble ?? 0,
      cedulapropie: data?.cedulapropie ?? "",
      nombrepropie: data?.nombrepropie ?? "",
      credito: data?.credito ?? 0,
    };
  },
};
